/* ==========================================================================
   WARMY - PDP INTERACTIONS
   Gallery thumbs + touch swipe, color chips (drive builder row 1 + main
   image + the prototype's color-reactive page theme), wear tabs, fit slider
   arrows, FAQ toggles, size-region toggle, sticky mobile CTA. Hooks are the
   prototype's own data-* attributes. Supports ?color= links from homepage
   swatches (preselects the colour on arrival).
   ========================================================================== */
(() => {
  'use strict';

  /* Colour chips: paint from the store's colour names. */
  const SWATCH = {
    'black': 'oklch(0.22 0.012 260)', 'green': 'oklch(0.53 0.075 147)', 'cream': 'oklch(0.93 0.027 83)',
    'pink': 'oklch(0.75 0.11 8)', 'dark gray': 'oklch(0.38 0.015 255)', 'purple': 'oklch(0.47 0.105 316)',
    'baby blue': 'oklch(0.78 0.075 238)', 'gray': 'oklch(0.70 0.012 255)', 'navy blue': 'oklch(0.30 0.062 264)',
    'red': 'oklch(0.44 0.17 27)', 'black + dog mom': 'oklch(0.22 0.012 260)', 'red + heart sleeve': 'oklch(0.44 0.17 27)'
  };
  document.querySelectorAll('.product-color-chip[data-color-name]').forEach((chip) => {
    const c = SWATCH[chip.dataset.colorName.toLowerCase().trim()];
    chip.style.setProperty('--color-chip', c || 'oklch(0.80 0.01 300)');
  });

  /* Color-reactive page theme - the prototype's productColorThemes, verbatim.
     Limited drops ("Black + Dog Mom") theme from their base color. */
  const PDP_THEMES = {
    'black': { accent: 'oklch(0.30 0.018 260)', deep: 'oklch(0.22 0.014 260)', soft: 'oklch(0.94 0.010 260)', wash: 'oklch(0.90 0.012 260)', on: 'oklch(0.99 0.004 55)' },
    'green': { accent: 'oklch(0.42 0.078 147)', deep: 'oklch(0.32 0.062 147)', soft: 'oklch(0.94 0.025 147)', wash: 'oklch(0.89 0.038 147)', on: 'oklch(0.99 0.004 55)' },
    'cream': { accent: 'oklch(0.49 0.055 78)', deep: 'oklch(0.37 0.045 74)', soft: 'oklch(0.97 0.024 82)', wash: 'oklch(0.93 0.035 82)', on: 'oklch(0.99 0.004 55)' },
    'pink': { accent: 'oklch(0.55 0.145 8)', deep: 'oklch(0.43 0.125 8)', soft: 'oklch(0.96 0.026 8)', wash: 'oklch(0.91 0.055 8)', on: 'oklch(0.99 0.004 55)' },
    'dark gray': { accent: 'oklch(0.39 0.020 255)', deep: 'oklch(0.28 0.016 255)', soft: 'oklch(0.94 0.012 255)', wash: 'oklch(0.89 0.016 255)', on: 'oklch(0.99 0.004 55)' },
    'purple': { accent: 'oklch(0.46 0.115 316)', deep: 'oklch(0.35 0.095 316)', soft: 'oklch(0.95 0.025 316)', wash: 'oklch(0.90 0.045 316)', on: 'oklch(0.99 0.004 55)' },
    'baby blue': { accent: 'oklch(0.48 0.085 238)', deep: 'oklch(0.36 0.070 238)', soft: 'oklch(0.96 0.022 238)', wash: 'oklch(0.91 0.040 238)', on: 'oklch(0.99 0.004 55)' },
    'gray': { accent: 'oklch(0.46 0.018 255)', deep: 'oklch(0.34 0.014 255)', soft: 'oklch(0.95 0.010 255)', wash: 'oklch(0.90 0.015 255)', on: 'oklch(0.99 0.004 55)' },
    'navy blue': { accent: 'oklch(0.35 0.085 260)', deep: 'oklch(0.26 0.070 260)', soft: 'oklch(0.94 0.020 260)', wash: 'oklch(0.89 0.035 260)', on: 'oklch(0.99 0.004 55)' },
    'red': { accent: 'oklch(0.47 0.175 25)', deep: 'oklch(0.36 0.145 25)', soft: 'oklch(0.96 0.026 25)', wash: 'oklch(0.91 0.050 25)', on: 'oklch(0.99 0.004 55)' },
    'mulberry': { accent: 'oklch(0.43 0.120 350)', deep: 'oklch(0.32 0.100 350)', soft: 'oklch(0.95 0.026 350)', wash: 'oklch(0.90 0.045 350)', on: 'oklch(0.99 0.004 55)' },
    'cocoa rose': { accent: 'oklch(0.49 0.085 32)', deep: 'oklch(0.37 0.070 32)', soft: 'oklch(0.96 0.027 35)', wash: 'oklch(0.91 0.046 35)', on: 'oklch(0.99 0.004 55)' },
    'oatmeal': { accent: 'oklch(0.50 0.055 68)', deep: 'oklch(0.38 0.045 68)', soft: 'oklch(0.97 0.022 72)', wash: 'oklch(0.93 0.035 72)', on: 'oklch(0.99 0.004 55)' }
  };
  const applyColorTheme = (colorRaw) => {
    if (!colorRaw) return;
    const base = String(colorRaw).split('+')[0].trim().toLowerCase();
    const theme = PDP_THEMES[base] || PDP_THEMES.black;
    const root = document.documentElement;
    root.style.setProperty('--pdp-accent', theme.accent);
    root.style.setProperty('--pdp-accent-deep', theme.deep);
    root.style.setProperty('--pdp-soft', theme.soft);
    root.style.setProperty('--pdp-benefits', theme.wash);
    root.style.setProperty('--pdp-fit', theme.wash);
    root.style.setProperty('--pdp-comparison', theme.soft);
    root.style.setProperty('--pdp-on-accent', theme.on);
    root.dataset.productColor = colorRaw;
  };

  const productData = (() => {
    try { return JSON.parse(document.querySelector('[data-warmy-product-data]').textContent); }
    catch { return null; }
  })();

  /* --- Gallery ------------------------------------------------------------- */
  const mainImg = document.querySelector('[data-main-image]');
  const setMain = (src, srcset, alt) => {
    if (!mainImg) return;
    if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
    mainImg.src = src;
    if (alt != null) mainImg.alt = alt;
  };
  document.querySelectorAll('.thumb[data-image]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.thumb').forEach((t) => t.setAttribute('aria-pressed', 'false'));
      thumb.setAttribute('aria-pressed', 'true');
      setMain(thumb.dataset.image, thumb.dataset.srcset, thumb.dataset.alt);
      const rail = document.querySelector('[data-media-benefits]');
      if (rail) rail.hidden = thumb.dataset.showBenefits !== 'true';
      const fit = document.querySelector('[data-model-fit]');
      if (fit) fit.hidden = thumb.dataset.showBenefits !== 'true';
    });
  });

  /* --- Gallery swipe (touch: drag the main image to change photos) ---------- */
  const mainMedia = document.querySelector('.main-media');
  const thumbList = [...document.querySelectorAll('.thumb[data-image]')];
  if (mainMedia && thumbList.length > 1) {
    mainMedia.style.touchAction = 'pan-y';
    let startX = 0, startY = 0, swiping = false;
    /* Touch events, NOT pointerup: with touch-action pan-y, iOS fires pointercancel
       the moment a drag reads as horizontal, so pointerup never delivered the end
       coordinates and swipes were dead on real phones. touchend always fires with
       final coords, and passive listeners keep vertical page scroll native. */
    mainMedia.addEventListener('touchstart', (e) => {
      const t = e.changedTouches[0];
      if (!t) return;
      swiping = true; startX = t.clientX; startY = t.clientY;
    }, { passive: true });
    mainMedia.addEventListener('touchend', (e) => {
      if (!swiping) return;
      swiping = false;
      const t = e.changedTouches[0];
      if (!t) return;
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      if (Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      const active = thumbList.findIndex((th) => th.getAttribute('aria-pressed') === 'true');
      const next = Math.min(thumbList.length - 1, Math.max(0, (active < 0 ? 0 : active) + (dx < 0 ? 1 : -1)));
      if (next === active) return;
      thumbList[next].click();
      thumbList[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }, { passive: true });
    mainMedia.addEventListener('touchcancel', () => { swiping = false; }, { passive: true });
  }

  /* --- Colour chips drive the builder's first row + the page theme ----------- */
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-product-color]');
    if (!chip) return;
    const color = chip.dataset.productColor;
    document.querySelectorAll('[data-product-color]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
    chip.setAttribute('aria-pressed', 'true');
    const label = document.querySelector('[data-selected-product-color]');
    if (label) label.textContent = color;
    applyColorTheme(color);

    const row0 = document.querySelector('[data-warmy-row="0"] [data-warmy-option="color"]');
    if (row0 && row0.value !== color) {
      row0.value = color;
      row0.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (productData && mainImg) {
      const ci = productData.optionIndex.color;
      const variant = productData.variants.find((v) => ci !== null && v.options[ci] === color && v.featuredImage);
      if (variant && variant.featuredImage) setMain(variant.featuredImage, '', color);
    }
  });

  /* Row 1's colour select also drives the chips + theme (both directions). */
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-warmy-row="0"] [data-warmy-option="color"]')) return;
    const color = e.target.value;
    if (!color) return;
    document.querySelectorAll('[data-product-color]').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.productColor === color)));
    const label = document.querySelector('[data-selected-product-color]');
    if (label) label.textContent = color;
    applyColorTheme(color);
  });

  /* Theme the page for the initially selected colour, or the colour carried in
     from a homepage swatch link (?color=Name). */
  const wantColor = new URLSearchParams(location.search).get('color');
  const wantChip = wantColor && [...document.querySelectorAll('[data-product-color]')]
    .find((c) => c.dataset.productColor.toLowerCase() === wantColor.toLowerCase());
  if (wantChip) wantChip.click();
  else applyColorTheme(document.querySelector('[data-product-color][aria-pressed="true"]')?.dataset.productColor);

  /* --- Wear tabs ---------------------------------------------------------------- */
  /* The media is responsive: swap srcset alongside src, otherwise the old
     srcset would keep winning over the new src and show the previous photo. */
  document.querySelectorAll('.wear-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.wear-tab').forEach((t) => t.setAttribute('aria-pressed', 'false'));
      tab.setAttribute('aria-pressed', 'true');
      const img = document.querySelector('[data-wear-main]');
      if (img && tab.dataset.wearImage) {
        if (tab.dataset.wearSrcset) img.srcset = tab.dataset.wearSrcset;
        else img.removeAttribute('srcset');
        img.src = tab.dataset.wearImage;
        img.alt = tab.dataset.wearAlt || '';
      }
      const h = document.querySelector('[data-wear-heading]');
      if (h) h.textContent = tab.dataset.wearTitle || '';
      const b = document.querySelector('[data-wear-body]');
      if (b) b.textContent = tab.dataset.wearCopy || '';
    });
  });

  /* --- Fit slider (mobile arrows) -------------------------------------------------- */
  const slider = document.querySelector('[data-fit-slider]');
  if (slider) {
    const cards = [...slider.querySelectorAll('.fit-card')];
    const status = document.querySelector('[data-fit-status]');
    const prev = document.querySelector('[data-fit-previous]');
    const next = document.querySelector('[data-fit-next]');
    const cardW = () => (cards[0]?.getBoundingClientRect().width || 300) + 10;
    const index = () => Math.round(slider.scrollLeft / cardW());
    const update = () => {
      const i = Math.min(index(), cards.length - 1);
      if (status) status.textContent = (i + 1) + ' of ' + cards.length;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= cards.length - 1;
    };
    prev?.addEventListener('click', () => slider.scrollBy({ left: -cardW(), behavior: 'smooth' }));
    next?.addEventListener('click', () => slider.scrollBy({ left: cardW(), behavior: 'smooth' }));
    slider.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  }

  /* --- FAQ ---------------------------------------------------------------------------- */
  document.querySelectorAll('.faq-button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (answer) answer.hidden = open;
      const mark = btn.querySelector('span:last-child');
      if (mark) mark.textContent = open ? '+' : '−';
    });
  });

  /* --- Size region toggle ---------------------------------------------------------------- */
  document.querySelectorAll('[data-size-region]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const region = btn.dataset.sizeRegion;
      document.querySelectorAll('[data-size-region]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      document.querySelectorAll('[data-size-row]').forEach((row) => { row.hidden = row.dataset.sizeRow !== region; });
    });
  });

  /* --- Size guide button -------------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-size-guide]')) return;
    const chart = document.querySelector('#size-chart .product-detail');
    if (chart) { chart.open = true; chart.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* --- Sticky mobile CTA ------------------------------------------------------------------------ */
  const trigger = document.querySelector('[data-mobile-purchase-trigger]');
  const sticky = document.querySelector('[data-mobile-purchase]');
  if (trigger && sticky) {
    new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', passed);
    }, { threshold: 0 }).observe(trigger);
    sticky.querySelector('[data-mobile-shop]')?.addEventListener('click', () => {
      document.getElementById('bundle-builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
